import * as React from 'react';
import { DatePicker } from '@app/src/components/DatePicker';
import { Field } from '@app/src/components/Field';

export const RenderDatePicker = ({
  label,
  type,
  portionWidth,
  meta: { error, touched },
  input,
  minDate,
  ...rest
}) => {
  let isError = (error && touched) ? error : '';
  return(
    <Field label={label} portionWidth={portionWidth} errorMessage={isError} {...rest}>
      <DatePicker
        type={type}
        minDate={minDate}
        readOnly
        date={input.value}
        uncontrolled
        {...input}
        {...rest}
        error={!!isError} />
    </Field>
  );
}
